import React from 'react';
import { NavLink } from 'react-router-dom';
import { apiGet, apiPost, apiPut } from '../../../services/apiClient';
import { getCurrentUserCompanyId, getCurrentUserSubCompanyId, getRoles } from '../../../services/userRights';
import CheckBoxInput from '../../../controls/checkBoxInput.jsx';
import SelectInput from '../../../controls/selectInput.jsx';
import TextInput from '../../../controls/textInput.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';
import NotFound from '../../notFound/notFound.jsx';

export default class AdminUserForm extends React.Component {
    constructor(args) {
        super(args);

        let userId = this.props.match.params.id;
        this.state = {
            id: userId ? userId : 0,
            busyCount: 0,
            lastResponseError: null,
            adminSubCompanyId: getCurrentUserSubCompanyId(),
            subCompanies: [],
            costCenters: [],
            carriers: [],
            roles: [],
            users: [],
            errors: {},
            user: {}
        };

        this.initUserData();
    }

    initUserData() {
        this.state.user = {
            wwid: "",
            login: "",
            password: "",
            email: "",
            name: "",
            surname: "",
            patronymic: "",
            isCrossSector: false,
            contactInfo: "",
            companyName: "",
            subCompanyId: null,
            costCenterId: null,
            carrierId: null,
            isActive: true,
            isBusinessPartner: false,
            responsibleUserId: null,
            roles: []
        };
    }

    componentDidMount() {
        this.reload();
    }

    componentWillReceiveProps(newProps) {
        let userId = newProps.match.params.id;
        this.state.id = userId ? userId : 0;
        this.setState(this.state, () => {
            if (this.state.id > 0) {
                this.reloadUserData();
            } else {
                this.initUserData();
                this.setState(this.state);
            }
        });
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    reload() {
        this.updateBusyCount(1);
        apiGet('ref/subcompanies/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.subCompanies = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('ref/roles/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.roles = data.entries.map((entry, ind, array) => { return { value: entry.name, label: entry.displayName }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('ref/users/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.users = data.entries.map((entry, ind, array) => { 
						return { 
							value: entry.id, 
							label: entry.fullName, 
							isCrossSector: entry.isCrossSector, 
							subCompanyId: entry.subCompanyId, 
							costCenterId: entry.costCenterId 
						}; 
					});
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.reloadUserData();
    }

    reloadUserData() {
        if (this.state.id > 0) {
            this.updateBusyCount(1);
            apiGet('admin/users/' + this.state.id)
                .then(data => {
                    this.updateBusyCount(-1);
                    data.password = "";
                    data.wwid = data.wwid ? data.wwid : "";
                    data.login = data.login ? data.login : "";
                    data.email = data.email ? data.email : "";
                    data.name = data.name ? data.name : "";
                    data.surname = data.surname ? data.surname : "";
                    data.patronymic = data.patronymic ? data.patronymic : "";
                    data.contactInfo = data.contactInfo ? data.contactInfo : "";
                    data.companyName = data.companyName ? data.companyName : "";
                    this.setState((prevState, props) => {
                        prevState.user = data;
                        return prevState;
                    });
                    this.reloadSectorsRefs(data.subCompanyId);
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                    if (err.status > 401) {
                        this.setState({ lastResponseError: err.status });
                    }
                });
        } else {
            let companyId = getCurrentUserCompanyId();
            this.updateBusyCount(1);
            apiGet('ref/companies/' + companyId)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        prevState.user.companyName = data.name;
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });

            this.setState((prevState, props) => {
                prevState.user.subCompanyId = prevState.adminSubCompanyId;
                return prevState;
            });

            this.reloadSectorsRefs(this.state.adminSubCompanyId);
        }
    }

    reloadSectorsRefs(subCompanyId) {
        let queryArgs = subCompanyId ? '' + subCompanyId : '';

        this.updateBusyCount(1);
        apiGet('ref/costcenters/list/' + queryArgs)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    let needClear = true;
                    prevState.costCenters = data.entries.map((entry, ind, array) => { 
                        if (entry.id === prevState.user.costCenterId) {
                            needClear = false;
                        }
						return { value: entry.id, label: entry.name }; 
					});
                    if (needClear) {
                        prevState.user.costCenterId = null;
                    }
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('ref/carriers/list/' + queryArgs)
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    let needClear = true;
                    prevState.carriers = data.entries.map((entry, ind, array) => { 
                        if (entry.id === prevState.user.carrierId) {
                            needClear = false;
                        }
						return { value: entry.id, label: entry.name }; 
					});
                    if (needClear) {
                        prevState.user.carrierId = null;
                    }
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    save() {
        let errors = this.validateForm();
        if (errors) {
            this.setErrors(errors);
        } else {
            var userData = {
                id: this.state.id,
                login: this.state.user.login,
                password: this.replaceEmptyString(this.state.user.password),
                email: this.replaceEmptyString(this.state.user.email),
                name: this.state.user.name,
                surname: this.state.user.surname,
                patronymic: this.replaceEmptyString(this.state.user.patronymic),
                isCrossSector: this.state.user.isCrossSector,
                contactInfo: this.replaceEmptyString(this.state.user.contactInfo),
                subCompanyId: this.state.user.subCompanyId,
                costCenterId: this.state.user.costCenterId,
                carrierId: this.state.user.carrierId,
                isActive: this.state.user.isActive,
                isBusinessPartner: this.state.user.isBusinessPartner,
                responsibleUserId: this.state.user.responsibleUserId,
                comment: this.state.user.comment,
                roles: this.state.user.roles
            };

            var applyMethod = null;
            if (this.state.id > 0) {
                applyMethod = apiPost('admin/users/' + this.state.id, userData);
            } else {
                applyMethod = apiPut('admin/users/new', userData);
            }
            
            applyMethod
                .then(() => {
                    this.backToList();
                })
                .catch(errors => {
                    this.setErrors(errors.messages);
                });
        }
    }

    setErrors(errors) {
        this.setState({ errors: errors });
    }

    replaceEmptyString(str) {
        if (this.isEmptyString(str)) {
            return null;
        } else {
            return str;
        }
    }

    validateForm() {
        var result = null;

        if (this.isEmptyString(this.state.user.login)) {
            result = result ? result : {};
            result.login = "Логин является обязательным полем";
        } else if (this.state.user.login.length > 200) {
            result = result ? result : {};
            result.login = "Длина поля Логин не должна превышать 200 символов";
        }

        if (this.state.id < 1 && this.isEmptyString(this.state.user.password)) {
            result = result ? result : {};
            result.password = "Пароль является обязательным полем";
        }

        if (!this.state.user.isCrossSector && !this.state.user.subCompanyId) {
            result = result ? result : {};
            result.subCompanyId = "Сектор является обязательным полем, так как не выставлен признак Кросс-функция";
        }

        if (this.state.user.isCrossSector && this.state.user.subCompanyId) {
            result = result ? result : {};
            result.isCrossSector = "Кросс-функция не может быть выставлен при заполненном Секторе";
        }

        if (this.state.user.isBusinessPartner && !this.state.user.responsibleUserId) {
            result = result ? result : {};
            result.responsibleUserId = "Ответственный сотрудник JnJ является обязательным полем, если выставлен признак Бизнес-партнер JnJ";
        }

        if (this.isEmptyString(this.state.user.name)) {
            result = result ? result : {};
            result.name = "Имя является обязательным полем";
        } else if (this.state.user.name.length > 200) {
            result = result ? result : {};
            result.name = "Длина поля Имя не должна превышать 200 символов";
        }

        if (this.isEmptyString(this.state.user.surname)) {
            result = result ? result : {};
            result.surname = "Фамилия является обязательным полем";
        } else if (this.state.user.surname.length > 200) {
            result = result ? result : {};
            result.surname = "Длина поля Фамилия не должна превышать 200 символов";
        }

        if (!this.isEmptyString(this.state.user.patronymic) && this.state.user.patronymic.length > 200) {
            result = result ? result : {};
            result.patronymic = "Длина поля Отчество не должна превышать 200 символов";
        }

        if (!this.isEmptyString(this.state.user.email) && this.state.user.email.length > 255) {
            result = result ? result : {};
            result.email = "Длина поля Email не должна превышать 255 символов";
        }

        if (!this.isEmptyString(this.state.user.contactInfo) && this.state.user.contactInfo.length > 500) {
            result = result ? result : {};
            result.contactInfo = "Длина поля Телефон не должна превышать 500 символов";
        }

        if (!this.isEmptyString(this.state.user.comment) && this.state.user.comment.length > 500) {
            result = result ? result : {};
            result.comment = "Длина поля Комментарий не должна превышать 500 символов";
        }

        if (!this.state.user.roles || this.state.user.roles.length < 1) {
            result = result ? result : {};
            result.roles = "Необходимо указать хотя бы одну роль";
        } else if (this.state.user.roles.length > 1 && this.state.user.roles.includes("Carrier")) {
            result = result ? result : {};
            result.roles = "Пользователь с ролью Транспортная компания не может иметь никаких других ролей";
		}

        if (!this.state.user.carrierId && this.state.user.roles.includes("Carrier")) {
            result = result ? result : {};
            result.carrierId = "Транспортная компания является обязательным полем для пользователей с соответствующей ролью";
        }

        return result;
    }

    isEmptyString(str) {
        return str === null || str === undefined || ("" + str).length === 0;
    }

    backToList() {
        this.props.history.push('/admin/users/list');
    }

    handleTextInputChange(name, value) {
        let user = this.state.user;
        user[name] = value;
        this.setState({
            user: user
        });
    }

    handleIsCrossSectorChange(value) {
        this.state.user.isCrossSector = value;
        if (this.state.user.isCrossSector) {
            this.state.user.subCompanyId = null;
            this.reloadSectorsRefs(null);
        }
        this.setState(this.state);
    }

    handleIsBusinessPartnerChange(value) {
        this.state.user.isBusinessPartner = value;
        if (!this.state.user.isBusinessPartner) {
            this.state.user.responsibleUserId = null;
        }
        this.setState(this.state);
    }

    handleSubCompanyChange(selection) {
        this.state.user.subCompanyId = selection ? selection.value : null;
        this.reloadSectorsRefs(this.state.user.subCompanyId);
        this.setState(this.state);
    }

    handleCostCenterChange(selection) {
        this.state.user.costCenterId = selection ? selection.value : null;
        this.setState(this.state);
    }

    handleCarrierChange(selection) {
        this.state.user.carrierId = selection ? selection.value : null;
        this.setState(this.state);
    }

    handleResponsibleUserChange(selection) {
        this.state.user.responsibleUserId = selection ? selection.value : null;
        this.state.user.isCrossSector = selection ? selection.isCrossSector : null;
        this.state.user.subCompanyId = selection ? selection.subCompanyId : null;
        this.state.user.costCenterId = selection ? selection.costCenterId : null;
        this.reloadSectorsRefs(this.state.user.subCompanyId);
        this.setState(this.state);
    }

    handleRolesChange(selection) {
        if (selection) {
            this.state.user.roles = selection.map((entry, ind, array) => entry.value);
        } else {
            this.state.user.roles = [];
        }
        this.setState(this.state);
    }

    render() {
        let roles = getRoles();
        let hasAccess = roles.includes('Admin');
        if (!hasAccess || this.state.lastResponseError === 403) {
            return <Forbidden />;
        }
        if (this.state.lastResponseError === 404) {
            return <NotFound />;
        }  

        let isNew = this.state.id < 1;
        let isBusy = this.state.busyCount > 0;
        let header = isNew
            ? (
                <section className="content-header">
                    <h1>Новый пользователь</h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li><NavLink to="/admin/users/list">Пользователи</NavLink></li>
                        <li className="active">Новый пользователь</li>
                    </ol>
                </section>
            )
            : (
                <section className="content-header">
                    <h1>Пользователь {this.state.user.login}</h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li><NavLink to="/admin/users/list">Пользователи</NavLink></li>
                        <li className="active">{this.state.user.login}</li>
                    </ol>
                </section>
            );
        let passwordPlaceholder = isNew ? "" : "Для смены пароля укажите новый...";
        return (
            <div>
                {header}
                <section className="content">
                    <div className="row">
                        <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                            <div className="box box-primary">
                                <div className="box-body">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className={"form-group" + (this.state.errors.wwid ? " has-error" : "")}>
                                                <label htmlFor="inputWWID">WWID</label>
                                                <TextInput id="inputWWID"
                                                    title={this.state.errors.wwid}
                                                    value={this.state.user.wwid}
                                                    disabled
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.login ? " has-error" : "")}>
                                                <label htmlFor="inputLogin">Логин</label>
                                                <TextInput id="inputLogin"
                                                    title={this.state.errors.login}
                                                    value={this.state.user.login}
                                                    onChange={value => this.handleTextInputChange("login", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.password ? " has-error" : "")}>
                                                <label htmlFor="inputPassword">Password</label>
                                                <TextInput type="password"
                                                    id="inputPassword"
                                                    placeholder={passwordPlaceholder}
                                                    title={this.state.errors.password}
                                                    value={this.state.user.password}
                                                    onChange={value => this.handleTextInputChange("password", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.surname ? " has-error" : "")}>
                                                <label htmlFor="inputSurname">Фамилия</label>
                                                <TextInput id="inputSurname"
                                                    title={this.state.errors.surname}
                                                    value={this.state.user.surname}
                                                    onChange={value => this.handleTextInputChange("surname", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.name ? " has-error" : "")}>
                                                <label htmlFor="inputName">Имя</label>
                                                <TextInput id="inputName"
                                                    title={this.state.errors.name}
                                                    value={this.state.user.name}
                                                    onChange={value => this.handleTextInputChange("name", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.patronymic ? " has-error" : "")}>
                                                <label htmlFor="inputPatronymic">Отчество</label>
                                                <TextInput id="inputPatronymic"
                                                    title={this.state.errors.patronymic}
                                                    value={this.state.user.patronymic}
                                                    onChange={value => this.handleTextInputChange("patronymic", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.email ? " has-error" : "")}>
                                                <label htmlFor="inputEmail">Email</label>
                                                <TextInput type="email"
                                                    id="inputEmail"
                                                    title={this.state.errors.email}
                                                    value={this.state.user.email}
                                                    onChange={value => this.handleTextInputChange("email", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.contactInfo ? " has-error" : "")}>
                                                <label htmlFor="inputContactInfo">Телефон</label>
                                                <TextInput id="inputContactInfo"
                                                    title={this.state.errors.contactInfo}
                                                    value={this.state.user.contactInfo}
                                                    onChange={value => this.handleTextInputChange("contactInfo", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="companyLabel">Юр. лицо</label>
                                                <TextInput id="companyLabel"
                                                    value={this.state.user.companyName}
                                                    disabled
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.subCompanyId ? " has-error" : "")}>
                                                <label htmlFor="selectSubCompany">Сектор</label>
                                                <SelectInput id="selectSubCompany"
                                                    options={this.state.subCompanies}
                                                    value={this.state.user.subCompanyId}
													title={this.state.errors.subCompanyId}
                                                    onChange={e => this.handleSubCompanyChange(e)}
                                                    disabled={isBusy || this.state.user.isCrossSector || this.state.user.isBusinessPartner}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.costCenterId ? " has-error" : "")}>
                                                <label htmlFor="selectCostCenter">Кост Центр</label>
                                                <SelectInput id="selectCostCenter"
                                                    options={this.state.costCenters}
                                                    value={this.state.user.costCenterId}
													title={this.state.errors.costCenterId}
                                                    onChange={e => this.handleCostCenterChange(e)}
                                                    disabled={isBusy || this.state.user.isBusinessPartner}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.roles ? " has-error" : "")}>
                                                <label htmlFor="selectRoles">Роли</label>
                                                <SelectInput id="selectRoles"
                                                    options={this.state.roles} multi
                                                    value={this.state.user.roles}
													title={this.state.errors.roles}
                                                    onChange={e => this.handleRolesChange(e)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.carrierId ? " has-error" : "")}>
                                                <label htmlFor="selectCarrier">Транспортная компания</label>
                                                <SelectInput id="selectCarrier"
                                                    options={this.state.carriers}
                                                    value={this.state.user.carrierId}
													title={this.state.errors.carrierId}
                                                    onChange={e => this.handleCarrierChange(e)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.comment ? " has-error" : "")}>
                                                <label htmlFor="inputComment">Комментарий</label>
                                                <TextInput id="inputComment"
                                                    title={this.state.errors.comment}
                                                    value={this.state.user.comment}
                                                    onChange={value => this.handleTextInputChange("comment", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.responsibleUserId ? " has-error" : "")}>
                                                <label htmlFor="selectResponsibleUser">Ответственный сотрудник JnJ</label>
                                                <SelectInput id="selectResponsibleUser"
                                                    options={this.state.users}
                                                    value={this.state.user.responsibleUserId}
													title={this.state.errors.responsibleUserId}
                                                    onChange={e => this.handleResponsibleUserChange(e)}
                                                    disabled={isBusy || !this.state.user.isBusinessPartner}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.isBusinessPartner ? " has-error" : "")}>
                                                <div className="checkbox">
                                                    <label>
                                                        <CheckBoxInput id="inputIsBusinessPartner"
                                                            title={this.state.errors.isBusinessPartner}
                                                            checked={this.state.user.isBusinessPartner}
                                                            onChange={value => this.handleIsBusinessPartnerChange(value)}
                                                            disabled={isBusy}
                                                        /> 
                                                        Бизнес-партнер JnJ
                                                    </label>
                                                </div>
                                            </div>

                                            <div className={"form-group" + (this.state.errors.isCrossSector ? " has-error" : "")}>
                                                <div className="checkbox">
                                                    <label>
                                                        <CheckBoxInput id="inputCrossSector"
                                                            title={this.state.errors.isCrossSector}
                                                            checked={this.state.user.isCrossSector}
                                                            onChange={value => this.handleIsCrossSectorChange(value)}
                                                            disabled={isBusy || this.state.user.isBusinessPartner}
                                                        /> 
                                                        Кросс-функция
                                                    </label>
                                                </div>
                                            </div>

                                            <div className={"form-group" + (this.state.errors.isActive ? " has-error" : "")}>
                                                <div className="checkbox">
                                                    <label>
                                                        <CheckBoxInput id="inputIsActive"
                                                            title={this.state.errors.isActive}
                                                            checked={this.state.user.isActive}
                                                            onChange={value => this.handleTextInputChange("isActive", value)}
                                                            disabled={isBusy}
                                                        /> 
                                                        Активный
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <button className="btn btn-flat btn-default" onClick={() => this.backToList()} disabled={isBusy}>
                                        Отмена
                                    </button>
                                    <button className="btn btn-flat btn-primary pull-right" onClick={() => this.save()} disabled={isBusy}>
                                        Сохранить
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/admin/users/userForm.jsx